
export const arrayUtil = {
    lastWhere,
    firstWhere
}

function lastWhere<T>(array:T[], predicate:(value:T, index:number)=>boolean):T|undefined
{
    for(let i = array.length-1; i >= 0; i--){
        if(predicate(array[i], i))
            return array[i];
    }
    return undefined;
}

function firstWhere<T>(array:T[], predicate:(value:T, index:number)=>boolean):T|undefined
{
    for(let i = 0; i < array.length; i++){
        if(predicate(array[i], i))
            return array[i];
    }
    return undefined;
}